module.exports = __webpack_public_path__ + "img/midway_house.c89f3302.jpg";